/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function checkVisible(rect) {
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

 document.addEventListener('DOMContentLoaded', function() {
  // Listen for scroll events
  var previousPos = "not set";
  var direction = "";

  //adjust background for parallax
  window.addEventListener('scroll', function (event) {
    var currPos = window.pageYOffset || document.documentElement.scrollTop;
    
    //set the previous position for use next time
    if(previousPos == "not set") {
      posOffset = 0;
    }
    else {
      posOffset = currPos - previousPos;
    }
    previousPos = currPos;

    var width  = window.innerWidth || document.documentElement.clientWidth || 
document.body.clientWidth;
    var pars = document.querySelectorAll(".image-with-parallax");
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    pars.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if(checkVisible(rect)) {
        //get background and adjust
        var par_back = el.querySelector(".parallax__background");
        var temp = par_back.style.transform;
        //get the previous position
        var ty = temp.replace('translateY(', '').replace('px)', '');
        if(ty != "") {
          ty = parseInt(ty);
        } else {
          ty = 0;
        }
        //in the adjustment
        var diff = ty + (posOffset/2);
        if(diff > 400) diff = 400;
        if(diff < 0) diff = 0;
        //move the background
        par_back.style.transform = 'translateY('+diff+'px)';
      }
    });
    
  });
 });